import React, { useState } from 'react';
import { GlobalContextData, GlobalContextProvider, GlobalContextVarType, globalVar } from '../classes/context';

interface GlobalContextProviderProps {
  children: React.ReactNode;
}

const GlobalProvider: React.FC<GlobalContextProviderProps> = ({ children }) => {
  const [vars, setVars] = useState<GlobalContextVarType>(globalVar);

  const update: GlobalContextData['update'] = (newData) => {
    setVars(newData);
  };

  return (
    <GlobalContextProvider value={{ vars, update }}>
      {children}
    </GlobalContextProvider>
  );
};

export default GlobalProvider;